export default "__VITE_ASSET__Jcd1twcW__"